export const MOIS = 'MOIS';
